import { render, staticRenderFns } from "./MoviePostersModal.vue?vue&type=template&id=516bc04e&scoped=true&"
import script from "./MoviePostersModal.vue?vue&type=script&lang=js&"
export * from "./MoviePostersModal.vue?vue&type=script&lang=js&"
import style0 from "./MoviePostersModal.vue?vue&type=style&index=0&id=516bc04e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516bc04e",
  null
  
)

export default component.exports